import _compact from 'lodash/compact';
import { useSelector } from 'react-redux';
import { selectIsAmpForEmailFeatureFlagOn } from 'core/userContext/selectors';
import { BasicSelect } from 'ui/selects';
import { useEditableFieldsContext } from '../context/EditableFieldsContext';
import { displayContent } from '../common/content';
import { EditorView } from '../common/types';

export const ContentEditorViewOptions = () => {
  const { contentEditorView, setContentEditorView } = useEditableFieldsContext();
  const ampForEmailEnabled = useSelector(selectIsAmpForEmailFeatureFlagOn);
  const contentEditorViewOptions = _compact([
    {
      id: 'wysiwyg-view-html',
      label: displayContent.labelEmailEditorViewHTML,
      value: EditorView.HTML,
    },
    {
      id: 'wysiwyg-view-text',
      label: displayContent.labelEmailEditorViewText,
      value: EditorView.TEXT,
    },
    ampForEmailEnabled && {
      id: 'wysiwyg-view-amp',
      label: displayContent.labelEmailEditorViewAMP,
      value: EditorView.AMP,
    },
  ]);
  return (
    <BasicSelect
      onSelect={(newView: EditorView[]) => setContentEditorView(newView[0])}
      id="email-editor-view"
      options={contentEditorViewOptions}
      defaultValues={[contentEditorView]}
    />
  );
};
